import React from 'react';
import Select from 'react-select';
import {Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import classnames from 'classnames';

import moment from 'moment';
import DatePicker from 'react-datepicker';

import DateTimePicker from 'component/DateTimePicker.js'

import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';
import FormHelper from '../../form.js';

// Phone number
/*import rrui from 'react-phone-number-input/rrui.css'
import rpni from 'react-phone-number-input/style.css'*/
import Phone from 'react-phone-number-input'

import toUTCtime from '../../../../helper/UTCtime.js';
import { toast } from 'react-toastify';

// Component
import ReminderRow from '../Row/ReminderRow.js';
import SelectQuery from '../../../../component/SelectQuery.js';

export default class ModalMaintenanceAdd extends React.Component {
  constructor(props) {
    super(props);
    this.IsPerAsset = props.hasOwnProperty('assetData') ? true : false

    this.state = {
      toggled            : false,
      toggledReminder    : false,
      overflow           : 'hidden',
      overflowReminder   : 'hidden',
      service            : '',
      asset              : '',
      description        : '',
      
      scheduledStart     : undefined,
      scheduledEnd       : '',
      nextScheduled      : '',
      
      scheduledStart_UTC : '',
      scheduledEnd_UTC   : '',
      nextScheduled_UTC  : null,

      repeatPeriod       : 0,
      repeatType         : 'days',
      isReminder         : '',
      isRepeating        : '',

      // Date
      minDate             : moment(),
      minDateScheduledEnd : moment(),
      minDateNextSchedule : moment().add(1, 'days'),

      // Register Reminder
      time     : null,
      time_UTC : null,
      method   : 'email',
      email    : '',
      mobile   : '',
      isOpen   : false,

      // temp reminder list
      tmpReminder: [],
      rowReminder: []
    }

    // Register
    this.onRegisterSuccess = this.onRegisterSuccess.bind(this);
    this.onRegisterReminderSuccess = this.onRegisterReminderSuccess.bind(this);
    this.onRegisterReminderFailed  = this.onRegisterReminderFailed.bind(this);
    
    // calendar
    this.onChangeTime = this.onChangeTime.bind(this)
    this.removeFromList = this.removeFromList.bind(this)
  }

  handleCheckboxChange(event) {
    if(event.target.name === 'isReminder') {
      this.setState({
        toggledReminder: event.target.checked,
        isReminder: event.target.checked ? 'Yes' : 'No'
      })
    } else {
      this.setState({
        toggled: event.target.checked,
        isRepeating: event.target.checked ? 'Yes' : 'No'
      })
    }
  }

  onOpen() {
    this.setState({overflow: 'visible'})
  }
  onClose() {
    this.setState({overflow: 'hidden'})
  }

  onOpenReminder() {
    this.setState({overflowReminder: 'visible'})
  }
  onCloseReminder() {
    this.setState({overflowReminder: 'hidden'})
  }

  /* Positive number only */
  positiveNumber(e) {
    if (e.target.validity.valid) {
      this.setState({repeatPeriod: e.target.value})
    }
  } 

  clear() {
    this.setState({
      service              : '',
      asset                : '',
      description          : '',  
      
      scheduledStart_UTC   : '',
      scheduledEnd_UTC     : '',
      repeatPeriod         : 0,
      repeatType           : 'days',
      scheduledStart       : '',
      scheduledEnd         : '',
      nextScheduled        : '',
      nextScheduled_UTC    : null,

      // Reset to off 
      toggledReminder      : false,
      isReminder           : 'No',

      // Reset to off 
      isRepeating          : 'No',
      toggled              : false,
      
      minDateScheduledEnd  : '',
      minDateNextSchedule  : '',

      // Clear list reminder
      rowReminder      : [],
      tmpReminder      : [],
    })
  }

 

  onChangeTime(date) {
    let tmpDate = new Date(date._d)
    
    this.setState({
      time     : date,
      time_UTC : toUTCtime(tmpDate)
    })
  }

  onChangeScheduledStart(date) {
    let tmpDate = new Date(date._d);
    let tmpDateEnd = moment(date).add(1, 'days')._d;
    
    tmpDate.setHours(0);
    tmpDate.setMinutes(0);
    tmpDate.setSeconds(0);

    tmpDateEnd.setHours(23);
    tmpDateEnd.setMinutes(59);
    tmpDateEnd.setSeconds(59);

    let endD = moment(date).add(1, 'days')

    let nextS = this.state.nextScheduled
    if (nextS){
      if (nextS < endD){
        nextS = moment(endD).add(1, 'days')
      }
    }

    this.setState({
      scheduledStart      : date,
      scheduledEnd        : moment(date).add(1, 'days'),
      minDateScheduledEnd : date,
      nextScheduled       : nextS,
      minDateNextSchedule : moment(date).add(2, 'days'),
      scheduledStart_UTC  : toUTCtime(tmpDate),
      scheduledEnd_UTC    : toUTCtime(tmpDateEnd),
    })
  }

  onChangeScheduledEnd(date) {
    let tmpDate = new Date(date._d);
    
    tmpDate.setHours(23);
    tmpDate.setMinutes(59);
    tmpDate.setSeconds(59);

    let nextS = this.state.nextScheduled
    if (nextS){
      if (nextS <= date){
        nextS = moment(date).add(1, 'days')
      }
    }

    this.setState({
      scheduledEnd        : date,
      scheduledEnd_UTC    : toUTCtime(tmpDate),
      nextScheduled       : nextS,
      minDateNextSchedule : moment(date).add(1, 'days'),
    })
  }

  onChangeNextScheduled(date) {
    let tmpDate = new Date(date._d);
    
    tmpDate.setHours(0);
    tmpDate.setMinutes(0);
    tmpDate.setSeconds(0);

    this.setState({
      nextScheduled     : date,
      nextScheduled_UTC : toUTCtime(tmpDate),
    })
  }

  onRegister() {
    if(!FormHelper.ValidateForm(this.state)) {
      return
    }
    Presenter.Register(RequestProperties.Register(this, this.onRegisterSuccess, this.onRegisterFailed))    
  }

  onRegisterSuccess(params, response) {
    if(response.data.IsReminder === "Yes") {
      for(let i=0; i < this.state.tmpReminder.length; i++) {
        this.onRegisterReminder(response.data.Alias, i);
      }
    }

    this.props.loadData();
    this.props.toggleModalAdd();

    toast.success("New maintenance has been successfully added")
  }

  onRegisterFailed(response) {
    console.log("Register Failed");
  }

  onRegisterReminder(work, index) {
    Presenter.RegisterReminder(
      RequestProperties.RegisterReminder(work, index, this, this.onRegisterReminderSuccess, this.onRegisterReminderFailed)
    )
  }

  onRegisterReminderSuccess(params, response) {
    // console.log(response);

  }

  onRegisterReminderFailed(response) {
    console.log('Register reminder failed');
  }

  generateRow(row) {
    var element = row.map((val, index) => {
      return (
        <ReminderRow
          rowData={val} 
          key={index}
          index={index}
          action="add"
          removeFromList={this.removeFromList}
        />
      )
    })
    return element;
  }

  closeConfirm() {
    if(this.state.tmpReminder.length >= 1 ) {
      let confirm = window.confirm("Are you sure to cancel, data will be lost!")
      if(confirm) {
        this.props.toggleModalAdd();
      }
    } else {
      this.props.toggleModalAdd();
    }

  }

  removeFromList(index) {   
    let tmp = this.state.tmpReminder;
    tmp.splice(index, 1);

    this.setState({
      rowReminder: this.generateRow(tmp),
      tmpReminder: tmp,
    })
  }

  addToList() {
    if(!FormHelper.validateFormReminder(this.state)) {
      return
    }
    let tmp = this.state.tmpReminder;

    let arrayList = {
      Method    : this.state.method,
      Email     : this.state.email,
      Mobile    : this.state.mobile,
      Time_UTC  : this.state.time_UTC,
      Time      : this.state.time,
    }

    tmp.unshift(arrayList)

    this.setState({
      rowReminder      : this.generateRow(tmp),
      tmpReminder      : tmp,
      overflowReminder : 'auto',
      email            : '',
      mobile           : '',
      time             : '',
      timeLocal        : ''
    })

    toast.success('Add reminder successfully')
  }

  willMount(){
    this.setState({
      asset : this.IsPerAsset ? this.props.assetData.Alias : '',
    })
  }

  renderMethod(method) {
    if(method === 'email') {
      return(
        <div className="form-group col-sm-9" style={{'paddingTop': '13px'}}>
          <label className="required">Email</label>
          <input 
            name="email"
            type="email" 
            className="form-control"
            value={this.state.email}
            onChange={(e)=>this.setState({email: e.target.value})}
          />
        </div>
      )
    } else if (method === 'mobile') {
      return (
        <div className="form-group col-sm-9" style={{'paddingTop': '13px'}}>
          <label className="required">Phone Number</label>
          <Phone
            className="form-control"
            placeholder="Enter phone number"
            value={ this.state.mobile }
            onChange={(val)=>this.setState({mobile: val}) } 
          />
        </div>
      )
    } else {
      return (
        <div className="col-sm-12">
          <div className="form-group ">
            <label className="required">Email</label>
            <input 
              name="email"
              type="email" 
              className="form-control"
              value={this.state.email}
              onChange={(e)=>this.setState({email: e.target.value})}
            />
          </div>
          <div className="form-group">
            <label className="required">Phone Number</label>
            <Phone
              className="form-control"
              placeholder="Enter phone number"
              value={ this.state.mobile }
              onChange={ mobile => this.setState({ mobile }) } 
            />
          </div>
        </div>
      )
    }
  }

  renderAssetField(){
    if(this.IsPerAsset){
      return(
        <input
          type="text" 
          className="form-control" 
          value={this.props.assetData.Name}
          disabled
        />
      )
    }else{
      return(
        <SelectQuery 
          placeholder="Type Asset"
          value={this.state.asset}
          onChange={(e) => this.setState({asset: e.value})}
          urlKey="read-asset-autocomplete"
          valKey="Alias"
          valLabel="Name"
          isCreatable={false}
          UserReducer={this.props.UserReducer}
        />
      )
    }

  }

  render() {
    const props = this.props;
    const {method} = this.state
    
    return (
      <Modal isOpen={props.modalAdd} onEnter={() => this.willMount()} onExit={()=>this.clear()} className="modal-lg" backdrop="static">
        <ModalHeader toggle={()=>this.closeConfirm()}>Add Maintenance</ModalHeader>
        <ModalBody>
          <div className="row">
            <div className="form-group col-sm-6">
              <label className="required">Asset / Tools</label>
              {this.renderAssetField()}
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Maintenance</label>
              <SelectQuery 
                placeholder="Type Maintenance"
                value={this.state.service}
                onChange={(e) => this.setState({service: e.value})}
                urlKey="read-maintenance-type-autocomplete"
                valKey="Alias"
                valLabel="Name"
                isCreatable={false}
                UserReducer={this.props.UserReducer}
              />
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Schedule Start</label>
              <DatePicker
                className="form-control"
                dateFormat="YYYY-MM-DD"
                minDate ={this.state.minDate}
                selected={this.state.scheduledStart}
                onChange={(e)=> this.onChangeScheduledStart(e) }
                readOnly
              />
              {/* <DateTimePicker
                minDate ={this.state.minDate}
                selected={this.state.scheduledStart}
                onChange={(e)=> this.onChangeScheduledStart(e) }
              /> */}
            </div>
            <div className="form-group col-sm-6">
              <label className="required">Schedule End</label>
              {/* <DateTimePicker
                minDate ={this.state.minDateScheduledEnd}
                selected={this.state.scheduledEnd}
                onChange={(e)=> this.onChangeScheduledEnd(e)}
              /> */}
              <DatePicker
                className="form-control"
                dateFormat="YYYY-MM-DD"
                minDate ={this.state.minDateScheduledEnd}
                selected={this.state.scheduledEnd}
                onChange={(e)=> this.onChangeScheduledEnd(e)}
                readOnly
              />
            </div>
            <div className="form-group col-md-12">
              <label className="optional">Next Schedule</label>
              <span 
                className="clear-date no-select" 
                onClick={()=>{this.setState({nextScheduled: '', nextScheduled_UTC: null})}}>clear</span>
              <DatePicker
                className="form-control"
                dateFormat="YYYY-MM-DD"
                minDate ={this.state.minDateNextSchedule}
                selected={this.state.nextScheduled}
                onChange={(e)=> this.onChangeNextScheduled(e)}
                readOnly
              />
              {/* <DateTimePicker
                minDate ={this.state.minDateNextSchedule}
                selected={this.state.nextScheduled}
                onChange={(e)=> this.onChangeNextScheduled(e)}
              /> */}
            </div>
            <div className="form-group col-sm-12">
              <label className="required">Description</label>
              <textarea 
                className="form-control" 
                cols="30" 
                rows="3"
                value={this.state.description}
                onChange={(e)=>this.setState({description: e.target.value})} 
              />
            </div>

            <div className="isRepeatLabel">
              <label className="spaceRRR mb0">Repeat</label>
              <label className="switch switch-sm switch-text switch-primary mb0">
                <input 
                  onChange={(event)=>this.handleCheckboxChange(event)} 
                  name='isRepeat'
                  type="checkbox" 
                  className="switch-input"
                  checked={this.state.toggled}
                />
                <span className="switch-label" data-on="On" data-off="Off"></span>
                <span className="switch-handle"></span>
              </label>
            </div>
            <div className={classnames('isRepeatBox', {open: this.state.toggled})} style={{'overflow': this.state.overflow}}>
              <div className="row">
                <div className="form-group col-sm-6" style={{'paddingTop': '13px'}}>
                  <label className="required">Repeat Period</label>
                  <input type="number"
                    className="form-control"
                    onChange={(e)=>this.positiveNumber(e)}
                    min="0"
                    pattern="^[0-9]"
                    name="repeartPeriod"
                    value={this.state.repeatPeriod}
                  />
                </div>
                <div className="form-group col-sm-6" style={{'paddingTop': '13px'}}>
                  <label>Repeat Type&nbsp;<small>(default : Days)</small></label>
                  <Select
                    name="service "
                    placeholder="Type Repeat Type"
                    onOpen={()=>this.onOpen()}
                    onClose={()=>this.onClose()}
                    clearable={false}
                    value={this.state.repeatType}
                    options={[
                      { value: 'days', label: 'Days' },
                      { value: 'weeks', label: 'Weeks' },
                      { value: 'months', label: 'Months' },
                      { value: 'years', label: 'Years' },
                    ]}
                    onChange={(val) => this.setState({repeatType: val.value})}
                  />
                </div>
              </div>
            </div>

            <div className="isRepeatLabel">     
              <label className="spaceRRR mb0">Use Reminder</label>
              <label className="switch switch-sm switch-text switch-primary mb0">
                <input 
                  onChange={(event)=>this.handleCheckboxChange(event)}
                  name='isReminder'
                  type="checkbox" 
                  className="switch-input" 
                  checked={this.state.toggledReminder}
                />
                <span className="switch-label" data-on="Yes" data-off="No"></span>
                <span className="switch-handle"></span>
              </label>
            </div>
            <div className={classnames('isRepeatBox', {open: this.state.toggledReminder})} style={{'overflowY': this.state.overflowReminder}}>
              <div className="row">
                <div className="form-group col-sm-3" style={{'paddingTop': '13px'}}>
                  <label>Method <small>(default email)</small></label>
                  <Select
                    name="method"
                    placeholder="Type Method"
                    value={this.state.method}
                    onOpen={()=>this.onOpenReminder()}
                    onClose={()=>this.onCloseReminder()}
                    options={[
                      { value: 'email', label: 'Email' },
                      { value: 'mobile', label: 'Mobile' },
                      { value: 'both', label: 'Both' },
                    ]}
                    clearable={false}
                    multi={false}
                    onChange={(val) => this.setState({method: val.value})}
                  />
                </div>
                {this.renderMethod(method)}
                <div className="form-group col-sm-12">
                  <label className="required">Remainder Time</label>
                    <DateTimePicker
                      selected={this.state.time}
                      onChange={this.onChangeTime}
                    />
                </div>
                <div className="col-sm-12 list-separator">
                  <div className="text-center">
                    <button type="button" onClick={()=>this.addToList()} className="btn btn-sm btn-primary"><i className="icon-arrow-down-circle"></i>&nbsp;&nbsp;Add to list</button>
                  </div>
                  <div className="item-inner">Reminder List</div>
                </div>
              </div>
              <table className="table table-striped table-responsive m-top-15 table">
                <thead>
                  <tr>
                    <th>Method</th>
                    <th>Email</th>
                    <th>Mobile</th>
                    <th>Time</th>
                    <th className="text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.rowReminder}
                </tbody>
              </table>
            </div>

          </div>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={()=>this.closeConfirm()}>Cancel</Button>
          <Button color="primary" onClick={()=>this.onRegister()}>Save</Button>
        </ModalFooter>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App/maintenance/helper/component/Modal/ModalMaintenanceAdd.js